import { ref } from "vue";
import { defineStore } from "pinia";
import { AuthService } from "@/utils/AuthService";

export const useOpenIdAuthenticationStore = defineStore("openIdAuthenticationStore", () => {
    const authService = ref<AuthService | undefined>();
    const isLoggedIn = ref<boolean>(false);

    const login = async () => {
        await authService.value?.signInRedirect();
    };

    const logout = async () => {
        await authService.value?.logout();
    };

    const logoutWithoutRedirect = async () => {
        await authService.value?.logoutWithoutRedirect();
    };

    const handleCallback = async () => {
        await authService.value?.handleCallback();
    };

    const getUser = async () => {
        try {
            return await authService.value?.getUser();
        } catch (error) {
            console.error("OpenIdAuthenticationStore: Failed to get user", error);

            return null;
        }
    };

    const getQueryStatus = async () => {
        try {
            const status = await authService.value?.getQueryStatus();

            isLoggedIn.value = true;

            return status;
        } catch (error) {
            console.error(error);

            isLoggedIn.value = false;
        }
    };

    const initialize = async () => {
        authService.value = new AuthService();

        return Promise.resolve();
    };

    return {
        login,
        logout,
        handleCallback,
        getUser,
        initialize,
        getQueryStatus,
        isLoggedIn,
        logoutWithoutRedirect
    };
});
